import { render, staticRenderFns } from "./ModalUserChangePassword.vue?vue&type=template&id=15b41484&"
import script from "./ModalUserChangePassword.vue?vue&type=script&lang=js&"
export * from "./ModalUserChangePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports